/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="8.28"
        height="17.82"
        viewBox="0 0 8.28 17.82"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M687,384.29h-2.5v8.91h-3.7v-8.91H679v-3.14h1.76v-2a3.47,3.47,0,0,1,3.74-3.73h2.74v3.05h-2a.75.75,0,0,0-.79.86v1.85h2.82Z"
          transform="translate(-679 -375.38)"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'FacebookIcon';

export default Icon;
